import toast from 'react-hot-toast'

type toastType = 'error' | 'success' | 'loading'

export const useToast = () => {
  const showToast = (message: string, typeToast: toastType) => toast[typeToast](message)

  return {
    showToast
  }
}
